export const ArrowDown = ({ className }) => {
  return (
    <svg
      className={className}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.718,4.291c-0.388-0.388-1.017-0.388-1.404,0L6,24.604v-7.596c0-0.552-0.448-1-1-1  s-1,0.448-1,1v10c0,0.265,0.103,0.521,0.291,0.709S4.735,28.008,5,28.008h10c0.552,0,1-0.448,1-1s-0.448-1-1-1H7.404L27.718,5.695  C28.106,5.307,28.106,4.679,27.718,4.291z"
        fill="#16a34a"
        id="Arrow_Down_Left"
      />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
};

export const ArrowUp = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.287,27.713c0.388,0.388,1.017,0.388,1.404,0L26.004,7.4v7.596c0,0.552,0.448,1,1,1  s1-0.448,1-1v-10c0-0.265-0.103-0.521-0.291-0.709s-0.444-0.291-0.709-0.291h-10c-0.552,0-1,0.448-1,1s0.448,1,1,1H24.6  L4.287,26.309C3.899,26.697,3.899,27.326,4.287,27.713z"
        fill="#dc2626"
        id="Arrow_Up_Right"
      />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
};

export const Search = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 512 512"
      width="512px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M344.5,298c15-23.6,23.8-51.6,23.8-81.7c0-84.1-68.1-152.3-152.1-152.3C132.1,64,64,132.2,64,216.3  c0,84.1,68.1,152.3,152.1,152.3c30.5,0,58.9-9,82.7-24.4l6.9-4.8L414.3,448l33.7-34.3L339.5,305.1L344.5,298z M301.4,131.2  c22.7,22.7,35.2,52.9,35.2,85c0,32.1-12.5,62.3-35.2,85c-22.7,22.7-52.9,35.2-85,35.2c-32.1,0-62.3-12.5-85-35.2  c-22.7-22.7-35.2-52.9-35.2-85c0-32.1,12.5-62.3,35.2-85c22.7-22.7,52.9-35.2,85-35.2C248.5,96,278.7,108.5,301.4,131.2z"
        fill="#1c56e2"
      />
    </svg>
  );
};

export const Filter = ({ className }) => {
  return (
    <svg
      className={className}
      enableBackground="new 0 0 32 32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="  M3.241,7.646L13,19v9l6-4v-5l9.759-11.354C29.315,6.996,28.848,6,27.986,6H4.014C3.152,6,2.685,6.996,3.241,7.646z"
        fill="none"
        id="XMLID_6_"
        stroke="#1c56e2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Copy = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 448 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z" />
    </svg>
  );
};

export const Arrow = ({ fill = "black", className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2553_9087)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 12C21 12.4142 20.6642 12.75 20.25 12.75H5.56031L11.0306 18.2194C11.3237 18.5124 11.3237 18.9876 11.0306 19.2806C10.7376 19.5737 10.2624 19.5737 9.96937 19.2806L3.21937 12.5306C3.07854 12.3899 2.99941 12.1991 2.99941 12C2.99941 11.8009 3.07854 11.6101 3.21937 11.4694L9.96937 4.71938C10.2624 4.42632 10.7376 4.42632 11.0306 4.71938C11.3237 5.01243 11.3237 5.48757 11.0306 5.78062L5.56031 11.25H20.25C20.6642 11.25 21 11.5858 21 12Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2553_9087">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SwapArrow = ({ fill = "#2741D6", className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.592 14.979L7.332 17.719C7.426 17.8123 7.476 17.9263 7.482 18.061C7.48867 18.1943 7.43867 18.3163 7.332 18.427C7.222 18.537 7.10333 18.592 6.976 18.592C6.84867 18.592 6.72967 18.537 6.619 18.427L3.236 15.044C3.14933 14.9573 3.08833 14.8683 3.053 14.777C3.01767 14.6856 3 14.5863 3 14.479C3 14.3716 3.01767 14.2723 3.053 14.181C3.08833 14.0896 3.14967 14.0006 3.237 13.914L6.625 10.525C6.72233 10.4276 6.837 10.3766 6.969 10.372C7.101 10.3673 7.22233 10.4203 7.333 10.531C7.43967 10.641 7.49367 10.759 7.495 10.885C7.49633 11.011 7.44233 11.129 7.333 11.239L4.593 13.979H11.479C11.621 13.979 11.74 14.0266 11.836 14.122C11.932 14.2173 11.9797 14.3363 11.979 14.479C11.9783 14.6216 11.9307 14.7406 11.836 14.836C11.7413 14.9313 11.6223 14.979 11.479 14.979H4.592ZM18.751 9.61397H11.864C11.722 9.61397 11.6033 9.56597 11.508 9.46997C11.4127 9.37397 11.3647 9.2553 11.364 9.11397C11.3633 8.97264 11.4113 8.85364 11.508 8.75697C11.6047 8.6603 11.7233 8.61264 11.864 8.61397H18.751L16.011 5.87397C15.917 5.77997 15.867 5.66597 15.861 5.53197C15.855 5.39797 15.905 5.27597 16.011 5.16597C16.121 5.0553 16.2397 4.99997 16.367 4.99997C16.495 4.99997 16.614 5.0553 16.724 5.16597L20.107 8.54797C20.1937 8.6353 20.2547 8.7243 20.29 8.81497C20.3253 8.9063 20.343 9.00597 20.343 9.11397C20.343 9.22197 20.3253 9.3213 20.29 9.41197C20.2553 9.50264 20.1943 9.59164 20.107 9.67897L16.718 13.068C16.6207 13.1653 16.506 13.2163 16.374 13.221C16.242 13.225 16.121 13.1716 16.011 13.061C15.9043 12.9516 15.85 12.834 15.848 12.708C15.846 12.582 15.9003 12.464 16.011 12.354L18.751 9.61397Z"
        fill={fill}
      />
    </svg>
  );
};

export const CardPay = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9.12534V8.32534C3 7.20534 3 6.64534 3.218 6.21734C3.41 5.84034 3.715 5.53534 4.092 5.34334C4.52 5.12534 5.08 5.12534 6.2 5.12534H17.8C18.92 5.12534 19.48 5.12534 19.907 5.34334C20.284 5.53534 20.59 5.84034 20.782 6.21734C21 6.64434 21 7.20434 21 8.32234V9.12534M3 9.12534H21M3 9.12534V15.9253C3 17.0453 3 17.6053 3.218 18.0333C3.40974 18.4096 3.71569 18.7156 4.092 18.9073C4.519 19.1253 5.079 19.1253 6.197 19.1253H17.803C18.921 19.1253 19.48 19.1253 19.907 18.9073C20.284 18.7153 20.59 18.4093 20.782 18.0333C21 17.6053 21 17.0473 21 15.9293V9.12534M6 15.1253H10"
        stroke="#2741D6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FundBank = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#ECEFFF" />
      <path
        d="M18.5 22H16.5V29H18.5V22ZM24.5 22H22.5V29H24.5V22ZM33 31H14V33H33V31ZM30.5 22H28.5V29H30.5V22ZM23.5 15.26L28.71 18H18.29L23.5 15.26ZM23.5 13L14 18V20H33V18L23.5 13Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const FundCard = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#ECEFFF" />
      <path
        d="M35.875 17.375V31.625C35.875 32.2781 35.6426 32.8374 35.1779 33.3029C34.7132 33.7684 34.1539 34.0008 33.5 34H14.5C13.8469 34 13.288 33.7676 12.8232 33.3029C12.3585 32.8382 12.1258 32.2789 12.125 31.625V17.375C12.125 16.7219 12.3578 16.163 12.8232 15.6982C13.2887 15.2335 13.8477 15.0008 14.5 15H33.5C34.1531 15 34.7124 15.2327 35.1779 15.6982C35.6434 16.1637 35.8758 16.7227 35.875 17.375ZM14.5 19.75H33.5V17.375H14.5V19.75ZM14.5 24.5V31.625H33.5V24.5H14.5Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const FundPhone = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="5" fill="#ECEFFF" />
      <path
        d="M28.2567 12H19.25C18.0072 12 17 13.0073 17 14.25V33.75C17 34.9928 18.0072 36 19.25 36H28.2567C29.4995 36 30.5067 34.9928 30.5067 33.75V14.25C30.5067 13.0073 29.4995 12 28.2567 12ZM29.0067 33.75C29.0067 34.164 28.6707 34.5 28.2567 34.5H19.25C18.836 34.5 18.5 34.164 18.5 33.75V14.25C18.5 13.836 18.836 13.5 19.25 13.5H28.2567C28.6707 13.5 29.0067 13.836 29.0067 14.25V33.75ZM23.7545 30.7541C22.9276 30.7541 22.2583 31.4242 22.2583 32.25C22.2583 33.0758 22.928 33.7463 23.7545 33.7463C24.5814 33.7463 25.2507 33.0758 25.2507 32.25C25.2507 31.4243 24.5814 30.7541 23.7545 30.7541ZM25.2545 14.25H22.2545C21.8405 14.25 21.5045 14.586 21.5045 15C21.5045 15.414 21.8405 15.75 22.2545 15.75H25.2545C25.6685 15.75 26.0045 15.414 26.0045 15C26.0045 14.586 25.6685 14.25 25.2545 14.25Z"
        fill="#2741D6"
      />
    </svg>
  );
};

export const KeypadDelete = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1485 17.617L15.1182 13.6473L19.0879 17.617L20.1485 16.5564L16.1788 12.5867L20.1485 8.61699L19.0879 7.5564L15.1182 11.5261L11.1485 7.5564L10.0879 8.61699L14.0575 12.5867L10.0879 16.5564L11.1485 17.617Z"
        fill="black"
      />
      <path
        d="M22.8682 3.58667H9.8671C9.71432 3.58695 9.56318 3.61821 9.42283 3.67858C9.28248 3.73894 9.15583 3.82714 9.05054 3.93786L1.49316 11.9127V13.2606L9.05054 21.2355C9.15583 21.3462 9.28248 21.4344 9.42283 21.4948C9.56318 21.5551 9.71432 21.5864 9.8671 21.5867H22.8682C23.1664 21.5863 23.4524 21.4677 23.6632 21.2568C23.8741 21.0459 23.9928 20.7599 23.9932 20.4617V4.71167C23.9928 4.41342 23.8741 4.12748 23.6632 3.91659C23.4524 3.70569 23.1664 3.58704 22.8682 3.58667ZM22.4932 20.0867H10.0284L2.99316 12.6627V12.5106L10.0284 5.08667H22.4932V20.0867Z"
        fill="black"
      />
    </svg>
  );
};

export const KeypadClear = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.26654 8.5867L3.55954 9.2937L2.85254 8.5867L3.55954 7.8797L4.26654 8.5867ZM9.26654 20.5867C9.00132 20.5867 8.74697 20.4813 8.55943 20.2938C8.3719 20.1063 8.26654 19.8519 8.26654 19.5867C8.26654 19.3215 8.3719 19.0671 8.55943 18.8796C8.74697 18.6921 9.00132 18.5867 9.26654 18.5867V20.5867ZM8.55954 14.2937L3.55954 9.2937L4.97354 7.8797L9.97354 12.8797L8.55954 14.2937ZM3.55954 7.8797L8.55954 2.8797L9.97354 4.2937L4.97354 9.2937L3.55954 7.8797ZM4.26654 7.5867H14.7665V9.5867H4.26654V7.5867ZM14.7665 20.5867H9.26654V18.5867H14.7665V20.5867ZM21.2665 14.0867C21.2665 15.8106 20.5817 17.4639 19.3627 18.6829C18.1437 19.9019 16.4904 20.5867 14.7665 20.5867V18.5867C15.3575 18.5867 15.9426 18.4703 16.4886 18.2442C17.0346 18.018 17.5307 17.6865 17.9485 17.2687C18.3664 16.8508 18.6979 16.3547 18.924 15.8088C19.1501 15.2628 19.2665 14.6776 19.2665 14.0867H21.2665ZM14.7665 7.5867C16.4904 7.5867 18.1437 8.27152 19.3627 9.49051C20.5817 10.7095 21.2665 12.3628 21.2665 14.0867H19.2665C19.2665 13.4958 19.1501 12.9106 18.924 12.3646C18.6979 11.8187 18.3664 11.3226 17.9485 10.9047C17.5307 10.4869 17.0346 10.1554 16.4886 9.92924C15.9426 9.70309 15.3575 9.5867 14.7665 9.5867V7.5867Z"
        fill="black"
      />
    </svg>
  );
};
